import { useState } from "react";
import PageHeader from "../../components/pageHeader";
import MainContentLayout from "../../components/mainContentLayout";
import { API_BASE } from "../../config/apiConfig";
import { useNavigate } from "react-router-dom";
import { FaUserCircle } from "react-icons/fa";

export default function SubscriptionSearchPage() {
  const navigate = useNavigate();
  const token = sessionStorage.getItem("access_token");

  const [query, setQuery] = useState("");
  const [results, setResults] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searchedOnce, setSearchedOnce] = useState(false);
  const [error, setError] = useState("");

  const MIN_CHARS = 3;

  const handleBlur = () => {
    if (query.trim().length > 0 && query.trim().length < MIN_CHARS) {
      setError(`Please enter at least ${MIN_CHARS} characters.`);
    } else {
      setError("");
    }
  };

  const handleSearch = async () => {
    if (query.trim().length < MIN_CHARS) {
      setError(`Please enter at least ${MIN_CHARS} characters.`);
      return;
    }

    setError("");
    setLoading(true);
    setResults([]);
    setSearchedOnce(true);

    try {
      const res = await fetch(
        `${API_BASE}/api/search_players?query=${encodeURIComponent(query)}`,
        {
          headers: { Authorization: `Bearer ${token}` }
        }
      );

      const data = await res.json();
      if (data.success) setResults(data.results);
    } catch (err) {
      console.error(err);
    }

    setLoading(false);
  };

  const isButtonDisabled = query.trim().length < MIN_CHARS;

  return (
    <MainContentLayout>
      <PageHeader title="Manage Subscription" backTo="/dashboard" />

      {/* Search Section */}
      <div className="mb-6">
        <div className="flex gap-2">
          <input
            type="text"
            placeholder="Search player by name or email..."
            value={query}
            onChange={(e) => setQuery(e.target.value)}
            onBlur={handleBlur}
            onKeyDown={(e) => e.key === "Enter" && handleSearch()}
            className={`placeholder:italic placeholder:text-gray-400 border px-3 py-2 rounded w-full ${
              error ? "border-red-500" : ""
            }`}
          />

          <button
            className={`px-4 rounded text-white ${
              isButtonDisabled
                ? "bg-gray-400 cursor-not-allowed"
                : "bg-blue-600 hover:bg-blue-700"
            }`}
            onClick={handleSearch}
            disabled={isButtonDisabled}
          >
            Search
          </button>
        </div>

        {error && <p className="text-red-500 text-sm mt-1">{error}</p>}
      </div>

      {/* Results */}
      {loading && <p>Searching...</p>}

      {!loading && searchedOnce && results.length === 0 && (
        <p>No matching players found.</p>
      )}

      {!loading && results.length > 0 && (
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-6">
          {results.map((player) => (
            <div
              key={player.user_id}
              onClick={() => navigate(`/subscription/${player.user_id}`, { state: { player } })}
              className="cursor-pointer bg-white border rounded-xl shadow p-4 flex flex-col items-center hover:shadow-md transition"
            >
              {player.photo ? (
                <img
                  src={player.photo}
                  alt="avatar"
                  className="w-20 h-20 rounded-full object-cover border mb-2"
                />
              ) : (
                <FaUserCircle className="w-20 h-20 text-gray-400 mb-2" />
              )}

              <p className="font-semibold text-center">{player.fullName}</p>
            </div>
          ))}
        </div>
      )}
    </MainContentLayout>
  );
}
